<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Contact Us Two</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Contact Us</li>
            </ul>
        </div>
    </div>
</div>
<!--============== Contact Area  ============-->
<div class="space">
    <div class="container">
        <div class="contact-infobox-top mb-2">
            <div class="row align-items-center justify-content-between text-center">
                <div class="col-xl-3 col-lg-3">
                    <div class="contact-shape-left text-sm-start">
                        <img src="assets/img/shape/contact-shape_2_1.png" alt="Contact" />
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="title-area contact-titlebox2 text-center">
                        <span class="sub-title">Drop Us a Line</span>
                        <h3 class="sec-title">Contact Information</h3>
                        <p class="sec-text">Reach out to Xipe Tech through our provided contact details, and our
                            dedicated team will respond promptly to ensure you get the information and support you
                            need.
                        </p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3">
                    <div class="contact-shape-right text-sm-end">
                        <img src="assets/img/shape/contact-shape_2_2.png" alt="Contact Us" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row gy-4">
            <div class="col-xl-5">
                <div class="contact-infobox smoke-bg">
                    <div class="about-contact-grid inner-style">
                        <span class="about-contact-icon">
                            <i class="fa-solid fa-headphones-simple"></i>
                        </span>
                        <div class="about-contact-details">
                            <span class="sec-text teko-600 text-dark fs-22px">Call Us For Query</span>
                            <p class="about-contact-details-text">
                                <a href="tel:+918090920216" class="fs-16px">(+91) 8090-920216</a>
                            </p>
                        </div>
                    </div>
                    <div class="about-contact-grid inner-style">
                        <span class="about-contact-icon">
                            <i class="fa-light fa-envelope-open-text"></i>
                        </span>
                        <div class="about-contact-details">
                            <span class="sec-text teko-600 text-dark fs-22px">Email Us Anytime</span>
                            <p class="about-contact-details-text">
                                <a href="mailto:hr&#64;xipetech.com" class="fs-16px">hr&#64;xipetech.com</a>
                            </p>
                        </div>
                    </div>
                    <div class="about-contact-grid inner-style">
                        <span class="about-contact-icon">
                            <i class="fa-thin fa-map-location-dot"></i>
                        </span>
                        <div class="about-contact-details">
                            <span class="sec-text teko-600 text-dark fs-22px">Visit Our Office</span>
                            <div class="about-contact-details-text">
                                <p class="fs-16px"> 1st Floor, 529C/486, Kamla Nehru Nagar,
                                    Jageshwarpuri,
                                    Shankar Purva-Ⅲ, Zone
                                    7,
                                    Lucknow - 226022 Uttar Pradesh, India
                                    Landmark: XT Building</p>
                            </div>
                            <div class="th-social dark-social-icon">
                                <a href="https://www.facebook.com/xipetech/"><i class="fab fa-facebook-f"></i></a>
                                <a href="https://x.com/xipetech/"><i class="fab fa-x"></i></a>
                                <a href="https://www.linkedin.com/company/xipe-tech/"><i
                                        class="fab fa-linkedin-in"></i></a>
                                <a href="https://www.youtube.com/@XipeTechLucknow"><i class="fab fa-youtube"></i></a>
                                <a href="https://www.instagram.com/xipe.tech/"><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-7">
                <div class="contact-formbox ms-xl-3 ps-xl-3">
                    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" method="POST" id="contactus-form" class="contact-form ajax-contact" novalidate enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-12">
                                <div *ngIf="successMessage" class="alert alert-success" role="alert">
                                    {{ successMessage }}
                                </div>

                                <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                                    {{ errorMessage }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 form-group">
                                <input type="text" class="form-control" formControlName="name" id="name3" placeholder="Your Name*" />
                                <img src="assets/img/icon/user.svg" alt="" maxlength="36">
                                <div *ngIf="hasError('name')" class="text-danger">
                                    {{ getErrorMessage('name') }}
                                </div>
                            </div>

                            <div class="col-sm-6 form-group">
                                <input type="email" class="form-control" formControlName="email" id="email" placeholder="Email Address*" />
                                <img src="assets/img/icon/mail.svg" alt="" maxlength="36" />
                                <div *ngIf="hasError('email')" class="text-danger">
                                    {{ getErrorMessage('email') }}
                                </div>
                            </div>

                            <div class="col-sm-6 form-group">
                                <input type="text" class="form-control" formControlName="phone" id="phone" placeholder="Phone Number*"
                                        (keypress)="onlyNumbers($event)" inputmode="numeric" maxlength="13" />
                                <img src="assets/img/icon/call.svg" alt="" />
                                <div *ngIf="hasError('phone')" class="text-danger">
                                    {{ getErrorMessage('phone') }}
                                </div>
                            </div>

                            <div class="col-sm-6 form-group">
                                <input type="text" class="form-control" formControlName="subject" id="subject" placeholder="Subject*" />
                                <img src="assets/img/icon/chat.svg" alt="" maxlength="128" />
                                <div *ngIf="hasError('subject')" class="text-danger">
                                    {{ getErrorMessage('subject') }}
                                </div>
                            </div>

                            <div class="form-group col-12">
                                <textarea formControlName="message" id="message" cols="30" rows="3" class="form-control"
                                            placeholder="Your Message*" maxlength="1024"></textarea>
                                <img src="assets/img/icon/plane4.svg" alt="" />
                                <div *ngIf="hasError('message')" class="text-danger">
                                    {{ getErrorMessage('message') }}
                                </div>
                            </div>

                            <div class="form-btn col-12">
                                <button type="submit" class="th-btn" [disabled]="isLoading">
                                    <span *ngIf="!isLoading">
                                    Submit Now <img src="assets/img/icon/plane4.svg" alt="">
                                    </span>
                                    <span *ngIf="isLoading" class="btn-loading">
                                    <span class="custom-spinner"></span> Submitting...
                                    </span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!--========== Map Area  =========-->
<div class="">
    <div class="contact-map style2">
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d444.78365920245443!2d80.96992900000001!3d26.894948!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399957e26aaaaab9%3A0xc729648a4f0c0fd0!2sXipe%20Tech!5e0!3m2!1sen!2sus!4v1754905470862!5m2!1sen!2sus"
            allowfullscreen="" loading="lazy"></iframe>
    </div>
</div>

<!--======== Footer Section ========-->
<app-footer></app-footer>